import styled, { css } from 'styled-components';
import { Button } from '@bechtel/gds';

export interface CarouselTrackStyledProps {
  translateX?: number;
}
export const CarouselStyled = styled.div`
  height: 100%;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  background-color: ${({ theme }) => theme.colors.grey[100]};
`;
export const CarouselTrackStyled = styled.div<CarouselTrackStyledProps>`
  display: flex;
  transition: transform 200ms ease;
  height: 100%;
  overflow-x: hidden;
  white-space: nowrap;
  ${(props) =>
    props.translateX &&
    css`
      transform: translate(calc(${props.translateX}px));
    `};
`;

export interface CarouselItemProps {
  selected?: boolean;
}
export const CarouselItemStyled = styled.li<CarouselItemProps>`
  display: inline-block;
  position: relative;
  margin-right: ${({ theme }) => theme.spacings[600]};
  height: 100%;
  padding-top: ${({ theme }) => theme.spacings[300]};
  padding-bottom: ${({ theme }) => theme.spacings[400]};
  & > * {
    height: 99.5%;

    ${(props) =>
      !props.selected &&
      css`
        opacity: 0.5;
      `};
    ${(props) =>
      props.selected &&
      css`
        height: 100%;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
      `};
  }

  ${(props) =>
    props.selected &&
    css`
      padding-top: ${({ theme }) => theme.spacings[100]};
      padding-bottom: ${({ theme }) => theme.spacings[350]};
    `};

  transition: transform 150ms ease;
`;

export const CarouselLeftButtonAreaStyled = styled.div`
  position: absolute;
  left: 0;
  z-index: 1;
  height: 100%;
  width: 10%;
`;

export const CarouselRightButtonAreaStyled = styled.div`
  position: absolute;
  right: 0;
  z-index: 1;
  height: 100%;
  width: 10%;
`;

export const CarouselButtonLeftStyled = styled(Button)`
  position: absolute;
  top: 50%;
  right: ${({ theme }) => theme.spacings[500]};
  width: 44px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;
export const CarouselButtonRightStyled = styled(Button)`
  position: absolute;
  left: ${({ theme }) => theme.spacings[500]};
  top: 50%;
  width: 44px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;

export const CarouselDisabledAreaStyled = styled.div`
  position: relative;
  height: 100%;
`;
